/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createPhi } from '../../factoriesAny.js';
export var phiDependencies = {
  BigNumberDependencies,
  createPhi
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesPhi.generated.js
// module id = xFL8
// module chunks = 3